var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBorder2BottomRightOpened = function SvgBorder2BottomRightOpened(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 654,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164 135.5V0M165 201v422c0 16.569-13.431 30-30 30H0",
    stroke: "#000"
  })));
};

export default SvgBorder2BottomRightOpened;